export default "__VITE_ASSET__C3xmUDFZ__"